class FdBundleProductsAccordion extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._onResize = () => {
      this.initializeHeights();
      this.setupScrollArea();
    };
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.fd-bundle-product-item');
    this.wrap = this.closest('.fd-bundle-accordion-wrap--scrollable');
    this.visibleCount = parseInt(this.dataset.visibleCount, 10) || 3;

    this.initializeHeights();
    this.setupScrollArea();

    this.items.forEach((item) => {
      const header = item.querySelector('.fd-bundle-product-item__header');
      if (header) header.addEventListener('click', () => this.toggleItem(item));
    });

    this.addEventListener('scroll', this._onScroll);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    this.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
  }

  setupScrollArea() {
    if (!this.wrap || this.items.length <= this.visibleCount) {
      if (this.wrap) {
        this.style.maxHeight = '';
        this.style.overflowY = '';
      }
      return;
    }

    const peekHeight = 50;
    let height = 0;

    for (let i = 0; i < this.visibleCount; i++) {
      height += this.items[i].offsetHeight;
    }

    const peekItem = this.items[this.visibleCount];
    if (peekItem) {
      height += Math.min(peekItem.offsetHeight, peekHeight);
    }

    this.style.maxHeight = height + 'px';
    this.style.overflowY = 'auto';
    this._updateScrollState();
  }

  _onScroll() {
    this._updateScrollState();
  }

  _updateScrollState() {
    if (!this.wrap) return;

    const hasScrolled = this.scrollTop > 8;
    const atEnd = this.scrollHeight - this.scrollTop - this.clientHeight < 8;

    this.wrap.classList.toggle('is-scrolled', hasScrolled);
    this.wrap.classList.toggle('is-at-end', atEnd);
  }

  initializeHeights() {
    this.items.forEach((item) => {
      const content = item.querySelector('.fd-bundle-product-item__content');
      const isActive = item.classList.contains('active');

      content.style.height = 'auto';
      content.style.overflow = 'visible';
      const naturalHeight = content.scrollHeight;

      content.dataset.naturalHeight = naturalHeight;

      if (isActive) {
        content.style.height = naturalHeight + 'px';
      } else {
        content.style.height = '0px';
      }
      content.style.overflow = 'hidden';
    });

    requestAnimationFrame(() => this.setupScrollArea());
  }

  toggleItem(item) {
    const content = item.querySelector('.fd-bundle-product-item__content');
    const isActive = item.classList.contains('active');

    this.items.forEach((i) => {
      const itemContent = i.querySelector('.fd-bundle-product-item__content');
      i.classList.remove('active');
      itemContent.style.height = '0px';
    });

    if (!isActive) {
      item.classList.add('active');
      const naturalHeight = content.dataset.naturalHeight || content.scrollHeight;
      content.style.height = naturalHeight + 'px';
    }

    requestAnimationFrame(() => this.setupScrollArea());
  }
}

if (!customElements.get('fd-bundle-products-accordion')) {
  customElements.define('fd-bundle-products-accordion', FdBundleProductsAccordion);
}

(function () {
  document.addEventListener('fathersday:tab-switch', function (e) {
    var tab = String(e.detail.tab);

    document.querySelectorAll('[data-fd-bundle-panel]').forEach(function (panel) {
      var isActive = panel.dataset.fdBundlePanel === tab;
      panel.classList.toggle('fd-bundle-panel--active', isActive);

      if (isActive) {
        panel.querySelectorAll('fd-bundle-products-accordion').forEach(function (accordion) {
          accordion.initializeHeights();
        });
      }
    });

    document.querySelectorAll('[data-fd-bundle-img]').forEach(function (img) {
      var isActive = img.dataset.fdBundleImg === tab;
      img.classList.toggle('fd-bundle-img-panel--active', isActive);
    });
  });
})();
